import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err) => {
        // Don't retry auth/permission failures.
        if (err instanceof Error && 'status' in err) {
          const status = (err as unknown as { status: number }).status;
          if (status === 401 || status === 402 || status === 404) return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
    },
    mutations: { retry: 0 },
  },
});
